import Offcanvas from '../../../../../components/new_offcanvas/offcanvas_menu'
import('../../../../../../styles/pages/charts/index/components/offcanvas_options.css')
import Form from './form/form'

export default function OffcanvasOptions(options){
    let offcanvas = new Offcanvas({
        id: options.id,
        title: "Opções de consulta",
        subtitle: "Informe as configurações da consulta",
        height: "offcanvas-hlg",
        width: "offcanvas-wmd",
        position:'right'
    })
    let form = new Form({container: "#options_form"})
    let button = undefined
    this.generate = () =>{
        offcanvas.generate()
        offcanvas.appendToBody("<div id='options_form'></div>")
        offcanvas.appendToBody("<div id='options_button_generate_chart'></div>")
        form.generate()

        generateButton()
    }

    this.form = _ =>{
        return form
    }

    this.show = () =>{
        offcanvas.show()
    }

    this.hide = () =>{
        offcanvas.hide()
    }

    this.getCurrentOptions = () =>{
        return form.getCurrentOptions()
    }

    function generateButton(){
        button = document.createElement('button')
        $(button).addClass("offcanvas-options-btn-generate-chart")
        button.type = 'button'
        $(button).html('<i class="far fa-chart-bar"></i> Gerar gráfico')
        offcanvas.appendToBody(button)

        button.onclick = () =>{
            $(document).trigger('dom-element-chart:click')
        }
    }
}